import { useContext } from 'react';

import type { BrandColorOptions } from './BrandAccentColorContext';
import { BrandAccentColorContext } from './BrandAccentColorContext';

export const useBrandAccentColorContext = (): BrandColorOptions => useContext(BrandAccentColorContext);
